import { render, staticRenderFns } from "./HPA.vue?vue&type=template&id=4fa1d55e&scoped=true"
import script from "./HPA.vue?vue&type=script&lang=js"
export * from "./HPA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa1d55e",
  null
  
)

export default component.exports